import { TranslatePipe } from '@thiememeulenhoff/ng-sdk';
import { Location } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AdminHeaderComponent } from '../admin-header/admin-header.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'edu-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslatePipe, AdminHeaderComponent, RouterOutlet],
})
export class AdminLayoutComponent {
  readonly #location = inject(Location);

  readonly #router = inject(Router);

  goBack(): void {
    if (window.history.length > 1) {
      this.#location.back();
      return;
    }

    this.#router.navigateByUrl('/');
  }
}
